import { isHttpError, rawHttp } from '../http';
import endpointConfig from '../config/endpointConfig';
import { CertInfo, CertQueryErrorCode } from '../entities/cert-info';

type CertInfoSuccess = {
	code: 'SUCCESS';
	data: CertInfo;
};

type CertInfoFailure = {
	code: CertQueryErrorCode | string;
	data?: unknown;
};

export type GetCertInfoResult =
	| { ok: true; data: CertInfo }
	| { ok: false; code: CertQueryErrorCode | 'UNKNOWN_ERROR'; message?: string };

export async function getCertInfo(
	certHash: string,
	serial: string,
): Promise<GetCertInfoResult> {
	try {
		const response = await rawHttp.get<CertInfoSuccess>(
			endpointConfig.certInfo(certHash, serial),
		);
		return { ok: true, data: response.data.data };
	} catch (error) {
		if (isHttpError(error) && error.response) {
			const body = error.response.data as CertInfoFailure | undefined;
			const code = body?.code;
			if (code === 'CA_HASH_NOT_FOUND' || code === 'SERIAL_NOT_FOUND_FOR_CA') {
				return { ok: false, code };
			}
		}
		return { ok: false, code: 'UNKNOWN_ERROR' };
	}
}
